import { classExpression } from "@babel/types";
import { Box, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down("md")]: {
      borderBottom: "1px solid #eee",
      backgroundColor: "#fff",
      padding: 0
    }
  },
  root: {
    backgroundColor: "#fff",
    border: "1px solid #DDDDDD",
    borderRadius: "6px",
    margin: "24px 0",
    [theme.breakpoints.down("md")]: {
      margin: "0",
      border: "none"
    }
  }
}));

export default function SectionWrapper(props: any) {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <div className={classes.root}>{props.children}</div>
    </Container>
  );
}
